import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotificationEditModalTID = (parentTestId)=>getTestIds(parentTestId);
